var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 11,
  viewBox: "0 0 18 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 2L9 9L16 2",
  stroke: "#BFC1C7",
  strokeWidth: 2.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgArrowDown as ReactComponent };